export function initMobileMenu() {
    const btnToggleMenu = document.querySelector('#btn-toggle-menu');
    const mobileMenu = document.querySelector('#mobile-menu');

    let menuOpened = false;
    let scrollY = 0;

    if (btnToggleMenu && mobileMenu) {
        btnToggleMenu.addEventListener('click', () => {
            btnToggleMenu.classList.toggle('btn--menu-opened');
            mobileMenu.classList.toggle('menu--opened');
            menuOpened = !menuOpened;
            if (menuOpened) disableScroll(); else enableScroll();
        });
    }

    if (mobileMenu) {
        mobileMenu.addEventListener('click', (e) => {
            const targetLink = e.target.closest('a');

            if (targetLink && targetLink.origin === window.location.origin && targetLink.pathname === window.location.pathname) {
                e.preventDefault();

                btnToggleMenu.classList.remove('btn--menu-opened');
                mobileMenu.classList.remove('menu--opened');
                menuOpened = false;

                enableScroll();
                window.location.href = e.target.getAttribute('href');
            }
        });
    }

    function disableScroll() {
        scrollY = window.scrollY;
        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add('disable-scroll');
        document.documentElement.classList.remove('scroll-smooth');
    }

    function enableScroll() {
        document.body.classList.remove('disable-scroll');
        document.body.style.top = '';
        window.scrollTo({ top: scrollY, behavior: 'instant'});
        document.documentElement.classList.add('scroll-smooth');
    }
}